import React, { useEffect, useState } from 'react';
import MainLayoutWithoutFooter from '../components/MainLayoutWithoutFooter';
import { useNavigate } from 'react-router-dom';
import { callAPI } from '../utils/apiUtils'; // Adjust the import path as necessary
import { apiUrls } from '../utils/apiUrls';

const OrderTransfer = () => {
  const navigate = useNavigate();

  const handleTransferTable = (e) => {
    e.preventDefault();
    navigate('/order-transfer-table');
  };

  const handleTransferOrder = (e) => {
    e.preventDefault();
    navigate('/order-transfer-order');
  };

  return (
    <MainLayoutWithoutFooter>
      <div class="pageContent transferOptionsPage dflexCol  pb-3">
        <div class="container">
            <div class="selectCustomerCol">
                <h4 class="lgTitle text-center pb-3">Transfer Options</h4>
                <div class="tfOptions">
                    <div class="tfOptionsStyle text-center"  >
                        <a href="/order-transfer-table" onClick={handleTransferTable} >
                            <div class="tfOptionsStyleImg">
                                <img src="images/transfer-icon1.svg" alt="..." />
                            </div>
                            <div class="tfOptionsStyleText">
                                <h4 class="mdText">Transfer a Table</h4>
                            </div>
                        </a>
                    </div>
                    <div class="tfOptionsStyle text-center"  >
                        <a href="/order-transfer-order" onClick={handleTransferOrder} >
                            <div class="tfOptionsStyleImg">
                                <img src="images/transfer-icon2.svg" alt="..." />
                            </div>
                            <div class="tfOptionsStyleText">
                                <h4 class="mdText">Transfer an Order</h4>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </MainLayoutWithoutFooter>
  );
};

export default OrderTransfer;